import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=3ff5062d&"
import script from "../descriptors/textarea.js?vue&type=script&lang=js&"
export * from "../descriptors/textarea.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports